export const EMAIL_NOTIFICATION_CREATE_REQUESTING = "EMAIL_NOTIFICATION_CREATE_REQUESTING";
export const EMAIL_NOTIFICATION_CREATE_SUCCESS = "EMAIL_NOTIFICATION_CREATE_SUCCESS";
export const EMAIL_NOTIFICATION_CREATE_ERROR = "EMAIL_NOTIFICATION_CREATE_ERROR";

export const EMAIL_NOTIFICATIONS_GET_REQUESTING = "EMAIL_NOTIFICATIONS_GET_REQUESTING";
export const EMAIL_NOTIFICATIONS_GET_SUCCESS = "EMAIL_NOTIFICATIONS_GET_SUCCESS";
export const EMAIL_NOTIFICATIONS_GET_ERROR = "EMAIL_NOTIFICATIONS_GET_ERROR";

export const EMAIL_NOTIFICATION_RESET_PAYMENT_PLAN_ID = "EMAIL_NOTIFICATION_RESET_PAYMENT_PLAN_ID";